import React from 'react';

import { Box, TablePagination } from '@mui/material';

import { ROWS_PER_PAGE_OPTIONS } from 'constants/constants';

import { useDevice } from 'hooks';

import PaginationActions from './PaginationActions';

import { styles } from './styles';

type Props = {
  fixed?: boolean;
  count: number;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions?: number[];
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
  handleChangeRowsPerPage?: (event: React.ChangeEvent<unknown>) => void;
};

const Pagination = ({
  fixed,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
  count = 0,
  rowsPerPage = 10,
  page = 0,
  handleChangePage,
  handleChangeRowsPerPage,
}: Props) => {
  const { isMobile } = useDevice();

  if (fixed) {
    return (
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        sx={styles.paginationContainer}
      >
        <TablePagination
          component="div"
          sx={styles.tablePagination}
          rowsPerPageOptions={rowsPerPageOptions}
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: { 'aria-label': 'rows per page' },
          }}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={isMobile ? undefined : (PaginationActions as any)}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count: total }) =>
            `${from}–${to} de ${total !== -1 ? total : `m\u00E1s de ${to}`}`
          }
          labelRowsPerPage={
            isMobile ? 'F. p\u00E1g.' : 'Filas por p\u00E1gina:'
          }
        />
      </Box>
    );
  }
  return (
    <TablePagination
      component="div"
      sx={styles.tablePagination}
      rowsPerPageOptions={rowsPerPageOptions}
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      SelectProps={{
        inputProps: { 'aria-label': 'rows per page' },
      }}
      onRowsPerPageChange={handleChangeRowsPerPage}
      ActionsComponent={isMobile ? undefined : (PaginationActions as any)}
      onPageChange={handleChangePage}
      labelDisplayedRows={({ from, to, count: total }) =>
        `${from}–${to} de ${total !== -1 ? total : `m\u00E1s de ${to}`}`
      }
      labelRowsPerPage={isMobile ? 'F. p\u00E1g.' : 'Filas por p\u00E1gina:'}
    />
  );
};

export default Pagination;
